import { ReactNode } from "react";
import { Navigate } from "react-router-dom";

interface AuthGuardProps {
  children: ReactNode;
}

/**
 * Wraps protected routes — redirects unauthenticated users to login.
 */
const AuthGuard = ({ children }: AuthGuardProps) => {
  const token = localStorage.getItem("user_access_token");
  const termsAgree = localStorage.getItem("terms_agree");

  if (!token || !termsAgree) {
    return <Navigate to="/login" replace />;
  }

  return <>{children}</>;
};

export default AuthGuard;
